import stencilReduxGlobalScript from '/home/vsts/work/1/s/frontendproject/node_modules/@stencil/redux/dist/collection/global/store.js';
import bcpcomponentsGlobalScript from '/home/vsts/work/1/s/frontendproject/src/globals/global.ts';
export const globalScripts = () => {
  return Promise.all([
    bcpcomponentsGlobalScript(),
    stencilReduxGlobalScript(),
  ]);
};
